export default "__VITE_ASSET__DhaSz8Xk__"